import {Component, Input, OnInit} from '@angular/core';
import {HttpClientService} from "../../../core/services/http-client.service";

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})

export class SectionComponent implements OnInit {
  @Input() section: any;
  relatedProducts: any = [];
  selectedIndex: number = 0;
  responsiveOptions: any[] = [
    {
      breakpoint: '991px',
      numVisible: 4
    },
    {
      breakpoint: '767px',
      numVisible: 3
    },
    {
      breakpoint: '575px',
      numVisible: 1
    }
  ];
  constructor(private http: HttpClientService) {
  }

  ngOnInit() {
    this.getRelatedProductsList();
  }

  getRelatedProductsList() {
    if (this.section.sectionBelow) {
      this.http.get(`store/listing/${this.section.sectionBelow}`).subscribe(models => {
        this.relatedProducts = models.response.fofoCatalogResponses;
      })
    }
  }

  changeIndex(index: number) {
    this.selectedIndex = index;
  }
}
